import { useDispatch, useSelector } from "react-redux";
import { GroupActivityD1API } from "../apis/GroupActivityD1API";
import { selectGroupActivityD1, changeStatus, onFetchGroupActivityD1 } from "../redux/slices/groupActivityD1Slice";
import { ApiStatus } from "../types/api/status";
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar";

export const useGroupActivityD1Store = () => {
    const dispatch = useDispatch();
    const { groupActivitiesD1, status } = useSelector(selectGroupActivityD1);

    const getGroupStructureD1Store = async (data?: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING));
            const response = await GroupActivityD1API.getGroupActivityD1(data);
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED));
                return CustomSnackbar("error", response.data.message || "");
            }
            const { detail } = response.data;
            dispatch(onFetchGroupActivityD1(detail));
            dispatch(changeStatus(ApiStatus.FETCHED));
            return true
        } catch (error) {
            console.log(error);
            return dispatch(changeStatus(ApiStatus.FETCHED));
        }
    };

    return {
        groupActivitiesD1,
        status,
        getGroupStructureD1Store,
    }
}